// removed by extract-text-webpack-plugin
module.exports = {"container":"_1sf0y-container","disabled":"_3w1ZW-disabled"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/Styles/Container.scss
// module id = 44
// module chunks = 0